import { useCallback } from 'react';
import { useGetSprintConfiguration } from 'queries/sprint-planning';
import { AccountFeature, useAccountFeature } from './use-account-feature';
export const useFilterPointsFieldsFromTaskFields = ()=>{
    const { data: sprintConfig } = useGetSprintConfiguration();
    const [isSprintPlaningFeatureEnabled] = useAccountFeature(AccountFeature.SprintPlanning);
    const { pointType: selectedPointType, pointsEnabled } = sprintConfig !== null && sprintConfig !== void 0 ? sprintConfig : {};
    const filterPointsFieldsFromTaskFields = useCallback((fields)=>{
        return fields.reduce((acc, field)=>{
            if (!sprintConfig || !pointsEnabled || !isSprintPlaningFeatureEnabled) {
                var _field_metaData;
                if (!((_field_metaData = field.metaData) === null || _field_metaData === void 0 ? void 0 : _field_metaData.pointType)) {
                    acc.push(field);
                }
            } else {
                var _field_metaData1, _field_metaData2, _field_metaData3;
                if (((_field_metaData1 = field.metaData) === null || _field_metaData1 === void 0 ? void 0 : _field_metaData1.pointType) && ((_field_metaData2 = field.metaData) === null || _field_metaData2 === void 0 ? void 0 : _field_metaData2.pointType) !== selectedPointType && pointsEnabled) {
                    return acc;
                }
                if ((_field_metaData3 = field.metaData) === null || _field_metaData3 === void 0 ? void 0 : _field_metaData3.pointType) {
                    acc.push({
                        ...field,
                        fieldLabel: 'Points'
                    });
                } else {
                    acc.push(field);
                }
            }
            return acc;
        }, []);
    }, [
        isSprintPlaningFeatureEnabled,
        pointsEnabled,
        selectedPointType,
        sprintConfig
    ]);
    return {
        filterPointsFieldsFromTaskFields
    };
};
